// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════
   Standard Page Layout System
   ═══════════════════════════════════════ */

/* ─── Page structure ─── */
.page-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--foreground);
  line-height: 1.3;
  letter-spacing: -0.01em;
  margin: 0;
}
.page-subtitle {
  font-size: 13px;
  color: var(--muted-foreground);
  margin: 4px 0 0;
  line-height: 1.4;
}

/* ─── Filter / action bar card ─── */
.filter-card {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.02);
}

/* ─── Content card wrapper (table container etc.) ─── */
.content-card {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.02);
}

/* ─── Dashboard card ─── */
.dash-card {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s ease, background-color 200ms ease, border-color 200ms ease;
}
.dash-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

/* ─── Consistent section spacing ─── */
.page-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ═══════════════════════════════════════
   Ant Design ➜ CSS-Variable Theme Overrides
   ═══════════════════════════════════════ */

/* ─── Override Ant Design CSS Variables with our theme ─── */
:root {
  --ant-color-bg-container: var(--card);
  --ant-color-bg-elevated: var(--popover);
  --ant-color-border: var(--border);
  --ant-color-border-secondary: var(--border);
  --ant-color-text: var(--foreground);
  --ant-color-text-secondary: var(--muted-foreground);
  --ant-color-text-tertiary: var(--muted-foreground);
  --ant-color-text-quaternary: var(--muted-foreground);
  --ant-color-text-placeholder: var(--muted-foreground);
  --ant-color-fill: var(--accent);
  --ant-color-fill-secondary: var(--muted);
  --ant-color-fill-tertiary: var(--muted);
  --ant-color-bg-layout: var(--background);
  --ant-control-item-bg-hover: var(--accent);
  --ant-control-item-bg-active: var(--accent);
  /* Global font size token */
  --ant-font-size: 13px;
  --ant-border-radius: 10px;
  --ant-border-radius-sm: 8px;
  --ant-border-radius-lg: 14px;
}

/* ─── Global font consistency ─── */
.ant-typography h1 { font-size: 24px !important; font-weight: 700 !important; letter-spacing: -0.02em; }
.ant-typography h2 { font-size: 20px !important; font-weight: 700 !important; letter-spacing: -0.01em; }
.ant-typography h3 { font-size: 17px !important; font-weight: 600 !important; }
.ant-typography h4 { font-size: 15px !important; font-weight: 600 !important; }
.ant-typography h5 { font-size: 13px !important; font-weight: 600 !important; }

/* ─── Statistic ─── */
.ant-statistic-title {
  font-size: 12px !important;
  font-weight: 500 !important;
  color: var(--muted-foreground) !important;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.ant-statistic-content-value {
  font-size: 26px !important;
  font-weight: 700 !important;
  color: var(--foreground) !important;
  letter-spacing: -0.02em;
}
.ant-statistic-content-prefix,
.ant-statistic-content-suffix {
  font-size: 16px !important;
  color: var(--muted-foreground) !important;
}

/* ─── Table ─── */
.ant-table {
  background: transparent !important;
  color: var(--foreground) !important;
}
.ant-table-container {
  border-radius: 14px !important;
  overflow: hidden;
}
.ant-table-thead > tr > th,
.ant-table-thead > tr > td {
  background: var(--muted) !important;
  color: var(--muted-foreground) !important;
  border-bottom: 1px solid var(--border) !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.03em !important;
  padding: 10px 16px !important;
}
.ant-table-thead > tr > th::before {
  display: none !important;
}
.ant-table-tbody > tr > td {
  background: var(--card) !important;
  color: var(--foreground) !important;
  border-bottom: 1px solid var(--border) !important;
  padding: 12px 16px !important;
  font-size: 13px !important;
  transition: background 0.15s ease;
}
/* AntD inserts a hidden measure row when scroll.x is set — keep it invisible
   (our td padding/border rule above must NOT turn it into a blank row). */
.ant-table-tbody > tr.ant-table-measure-row > td {
  padding: 0 !important;
  height: 0 !important;
  border: 0 !important;
}
.ant-table-tbody > tr:hover > td {
  background: var(--accent) !important;
}
.ant-table-tbody > tr.ant-table-row-selected > td {
  background: var(--accent) !important;
}
/* Empty state */
.ant-table-placeholder td {
  background: var(--card) !important;
  border-bottom: none !important;
}
.ant-table-placeholder:hover td {
  background: var(--card) !important;
}
.ant-empty-description {
  color: var(--muted-foreground) !important;
}
.ant-empty-image svg {
  fill: var(--muted-foreground) !important;
}
/* Table wrapper */
.ant-table-wrapper {
  border-radius: 16px;
}
/* Cell text inside table */
.ant-table-cell {
  color: var(--foreground) !important;
}
/* Thin scrollbar for horizontally/vertically scrollable tables */
.ant-table-body,
.ant-table-content {
  scrollbar-width: thin;
  scrollbar-color: var(--border) transparent;
}
.ant-table-body::-webkit-scrollbar,
.ant-table-content::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}
.ant-table-body::-webkit-scrollbar-thumb,
.ant-table-content::-webkit-scrollbar-thumb {
  background: var(--border);
  border-radius: 4px;
}
.ant-table-body::-webkit-scrollbar-track,
.ant-table-content::-webkit-scrollbar-track {
  background: transparent;
}

/* ─── Pagination ─── */
.ant-pagination .ant-pagination-item {
  background: var(--card) !important;
  border-color: var(--border) !important;
}
.ant-pagination .ant-pagination-item a {
  color: var(--foreground) !important;
}
.ant-pagination .ant-pagination-item-active {
  background: var(--primary) !important;
  border-color: var(--primary) !important;
}
.ant-pagination .ant-pagination-item-active a {
  color: var(--primary-foreground) !important;
}
.ant-pagination .ant-pagination-prev .ant-pagination-item-link,
.ant-pagination .ant-pagination-next .ant-pagination-item-link {
  color: var(--foreground) !important;
  background: var(--card) !important;
  border-color: var(--border) !important;
}
.ant-pagination .ant-pagination-disabled .ant-pagination-item-link {
  color: var(--muted-foreground) !important;
  opacity: 0.5;
}
.ant-pagination .ant-pagination-total-text {
  color: var(--muted-foreground) !important;
}
.ant-pagination .ant-pagination-options .ant-select-selector {
  background: var(--card) !important;
  border-color: var(--border) !important;
  color: var(--foreground) !important;
}

/* ─── Input ─── */
.ant-input,
.ant-input-affix-wrapper {
  background: var(--card) !important;
  border-color: var(--border) !important;
  color: var(--foreground) !important;
  border-radius: 10px !important;
  font-size: 13px !important;
  height: 36px !important;
}
.ant-input-affix-wrapper .ant-input {
  height: auto !important;
}
.ant-input-sm,
.ant-input-affix-wrapper-sm {
  height: 28px !important;
  border-radius: 6px !important;
  font-size: 12px !important;
}
.ant-input-lg,
.ant-input-affix-wrapper-lg {
  height: 42px !important;
  border-radius: 10px !important;
  font-size: 14px !important;
}
.ant-input::placeholder,
.ant-input-affix-wrapper .ant-input::placeholder {
  color: var(--muted-foreground) !important;
}
.ant-input:hover,
.ant-input-affix-wrapper:hover {
  border-color: var(--ring) !important;
}
.ant-input:focus,
.ant-input-affix-wrapper-focused {
  border-color: var(--ring) !important;
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--ring) 12%, transparent) !important;
}
.ant-input-prefix {
  color: var(--muted-foreground) !important;
}
/* TextArea should not have fixed height */
.ant-input[type="textarea"],
textarea.ant-input {
  height: auto !important;
  min-height: 80px;
}

/* ─── Select ─── */
.ant-select .ant-select-selector {
  background-color: var(--card) !important;
  border-color: var(--border) !important;
  color: var(--foreground) !important;
  border-radius: 10px !important;
  font-size: 13px !important;
  height: 36px !important;
  align-items: center !important;
}
.ant-select-sm .ant-select-selector {
  height: 28px !important;
  border-radius: 6px !important;
  font-size: 12px !important;
}
.ant-select-lg .ant-select-selector {
  height: 42px !important;
  border-radius: 10px !important;
  font-size: 14px !important;
}
.ant-select:hover .ant-select-selector {
  border-color: var(--ring) !important;
}
.ant-select-focused .ant-select-selector {
  border-color: var(--ring) !important;
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--ring) 12%, transparent) !important;
}
.ant-select-selection-placeholder {
  color: var(--muted-foreground) !important;
}
.ant-select-selection-item {
  color: var(--foreground) !important;
}
.ant-select-arrow {
  color: var(--muted-foreground) !important;
}
.ant-select-clear {
  background-color: var(--card) !important;
  color: var(--muted-foreground) !important;
}
/* Select dropdown */
.ant-select-dropdown {
  background-color: var(--popover) !important;
  border: 1px solid var(--border) !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06) !important;
  padding: 4px !important;
}
.ant-select-item {
  color: var(--foreground) !important;
  border-radius: 6px !important;
  font-size: 13px !important;
}
.ant-select-item-option-active {
  background-color: var(--accent) !important;
}
.ant-select-item-option-selected {
  background-color: var(--accent) !important;
  color: var(--foreground) !important;
}
/* Checkmark on selected options (multiple mode) */
.ant-select-item-option-selected .ant-select-item-option-state {
  color: var(--primary) !important;
}

/* ─── Multiple select — grow with tag chips instead of a fixed height ───
   The single-select rules above pin .ant-select-selector to a fixed height,
   which clips the tag chips of a multiple select when they wrap. Let the
   box grow (min-height) and style the chips for the current theme. */
.ant-select-multiple .ant-select-selector {
  height: auto !important;
  min-height: 36px !important;
  padding-block: 3px !important;
  padding-inline: 4px !important;
  align-items: center !important;
}
.ant-select-sm.ant-select-multiple .ant-select-selector {
  height: auto !important;
  min-height: 28px !important;
}
.ant-select-lg.ant-select-multiple .ant-select-selector {
  height: auto !important;
  min-height: 42px !important;
}
.ant-select-multiple .ant-select-selection-item {
  background-color: var(--secondary) !important;
  border: 1px solid var(--border) !important;
  border-radius: 6px !important;
  color: var(--foreground) !important;
  height: 24px !important;
  line-height: 22px !important;
  display: inline-flex !important;
  align-items: center !important;
}
.ant-select-sm.ant-select-multiple .ant-select-selection-item {
  height: 20px !important;
  line-height: 18px !important;
  font-size: 11px !important;
}
.ant-select-multiple .ant-select-selection-item-remove {
  color: var(--muted-foreground) !important;
  display: inline-flex !important;
  align-items: center !important;
}
.ant-select-multiple .ant-select-selection-item-remove:hover {
  color: var(--foreground) !important;
}

/* ─── Button ─── */
.ant-btn {
  height: 36px !important;
  border-radius: 10px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  padding-inline: 14px !important;
  box-shadow: none !important;
  transition: all 0.15s ease !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
}
.ant-btn.ant-btn-sm {
  height: 28px !important;
  border-radius: 6px !important;
  font-size: 12px !important;
  padding-inline: 10px !important;
}
.ant-btn.ant-btn-lg {
  height: 42px !important;
  border-radius: 10px !important;
  font-size: 14px !important;
  padding-inline: 18px !important;
}
.ant-btn.ant-btn-circle {
  width: 36px !important;
  padding-inline: 0 !important;
  border-radius: 50% !important;
}
.ant-btn.ant-btn-circle.ant-btn-sm {
  width: 28px !important;
}
.ant-btn-default,
.ant-btn-variant-outlined {
  background: var(--card) !important;
  border-color: var(--border) !important;
  color: var(--foreground) !important;
}
.ant-btn-default:hover,
.ant-btn-variant-outlined:hover {
  border-color: var(--ring) !important;
  color: var(--foreground) !important;
}
.ant-btn-text,
.ant-btn-variant-text {
  color: var(--foreground) !important;
  border-color: transparent !important;
  background: transparent !important;
}
.ant-btn-text:hover,
.ant-btn-variant-text:hover {
  background: var(--accent) !important;
}
.ant-btn-text.ant-btn-dangerous,
.ant-btn-variant-text.ant-btn-dangerous {
  color: var(--destructive) !important;
}
.ant-btn-text.ant-btn-dangerous:hover,
.ant-btn-variant-text.ant-btn-dangerous:hover {
  background: color-mix(in srgb, var(--destructive) 10%, transparent) !important;
}
.ant-btn-primary,
.ant-btn-variant-solid,
.ant-btn-color-primary.ant-btn-variant-solid {
  background: var(--primary) !important;
  border-color: var(--primary) !important;
  color: var(--primary-foreground) !important;
  box-shadow: 0 1px 3px color-mix(in srgb, var(--primary) 20%, transparent), 0 1px 2px color-mix(in srgb, var(--primary) 12%, transparent) !important;
}
.ant-btn-primary:hover,
.ant-btn-variant-solid:hover,
.ant-btn-color-primary.ant-btn-variant-solid:hover {
  background: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
  color: var(--primary-foreground) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-1px) !important;
}

/* ─── Modal ─── */
.ant-modal-content {
  background: var(--card) !important;
  color: var(--foreground) !important;
  border-radius: 16px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08) !important;
  padding: 0 !important;
  overflow: hidden;
}
.ant-modal-header {
  background: var(--card) !important;
  border-bottom: 1px solid var(--border) !important;
  padding: 16px 24px !important;
  margin: 0 !important;
}
.ant-modal-title {
  color: var(--foreground) !important;
  font-size: 15px !important;
  font-weight: 600 !important;
}
.ant-modal-body {
  padding: 20px 24px !important;
}
.ant-modal-footer {
  border-top: 1px solid var(--border) !important;
  padding: 12px 24px !important;
  margin: 0 !important;
}
.ant-modal-close {
  color: var(--muted-foreground) !important;
  top: 14px !important;
  right: 16px !important;
}
.ant-modal-close:hover {
  color: var(--foreground) !important;
  background: var(--accent) !important;
}

/* ─── Form ─── */
.ant-form-item-label > label {
  color: var(--foreground) !important;
  font-size: 13px !important;
  font-weight: 500 !important;
}
.ant-form-item-explain-error {
  color: var(--destructive) !important;
  font-size: 12px !important;
}
.ant-form-item-extra {
  color: var(--muted-foreground) !important;
  font-size: 12px !important;
}
.ant-form-item {
  margin-bottom: 16px !important;
}

/* ─── Tag ─── */
.ant-tag {
  border-radius: 6px !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  padding: 2px 8px !important;
  line-height: 20px !important;
  border: none !important;
}
/* Theme-aware preset tag colors — we set BOTH text and background per preset,
   per theme, so tags are always legible regardless of Ant Design's algorithm
   state (which proved unreliable across theme switches). Status hues stay
   semantic per the design system. Solid custom-hex tags (.ant-tag-has-color)
   keep their own fill and are excluded. */

/* Default / neutral (no preset color) */
.ant-tag:not(.ant-tag-has-color) {
  color: var(--muted-foreground) !important;
  background: var(--muted) !important;
}

/* ── Light (default for all light themes) ── */
.ant-tag-blue:not(.ant-tag-has-color),
.ant-tag-processing:not(.ant-tag-has-color)   { color:#2563eb !important; background:#eff6ff !important; }
.ant-tag-cyan:not(.ant-tag-has-color)         { color:#0891b2 !important; background:#ecfeff !important; }
.ant-tag-green:not(.ant-tag-has-color),
.ant-tag-success:not(.ant-tag-has-color)      { color:#16a34a !important; background:#f0fdf4 !important; }
.ant-tag-red:not(.ant-tag-has-color),
.ant-tag-error:not(.ant-tag-has-color)        { color:#dc2626 !important; background:#fef2f2 !important; }
.ant-tag-orange:not(.ant-tag-has-color),
.ant-tag-volcano:not(.ant-tag-has-color)      { color:#ea580c !important; background:#fff7ed !important; }
.ant-tag-gold:not(.ant-tag-has-color),
.ant-tag-warning:not(.ant-tag-has-color)      { color:#b45309 !important; background:#fffbeb !important; }
.ant-tag-purple:not(.ant-tag-has-color)       { color:#9333ea !important; background:#faf5ff !important; }
.ant-tag-magenta:not(.ant-tag-has-color),
.ant-tag-pink:not(.ant-tag-has-color)         { color:#db2777 !important; background:#fdf2f8 !important; }
.ant-tag-geekblue:not(.ant-tag-has-color)     { color:#4f46e5 !important; background:#eef2ff !important; }
.ant-tag-lime:not(.ant-tag-has-color)         { color:#65a30d !important; background:#f7fee7 !important; }

/* ── Dark overrides ── */
:root[data-mode="dark"] .ant-tag-blue:not(.ant-tag-has-color),
:root[data-mode="dark"] .ant-tag-processing:not(.ant-tag-has-color) { color:#60a5fa !important; background:rgba(59,130,246,.16) !important; }
:root[data-mode="dark"] .ant-tag-cyan:not(.ant-tag-has-color)       { color:#22d3ee !important; background:rgba(6,182,212,.16) !important; }
:root[data-mode="dark"] .ant-tag-green:not(.ant-tag-has-color),
:root[data-mode="dark"] .ant-tag-success:not(.ant-tag-has-color)    { color:#4ade80 !important; background:rgba(34,197,94,.16) !important; }
:root[data-mode="dark"] .ant-tag-red:not(.ant-tag-has-color),
:root[data-mode="dark"] .ant-tag-error:not(.ant-tag-has-color)      { color:#f87171 !important; background:rgba(239,68,68,.16) !important; }
:root[data-mode="dark"] .ant-tag-orange:not(.ant-tag-has-color),
:root[data-mode="dark"] .ant-tag-volcano:not(.ant-tag-has-color)    { color:#fb923c !important; background:rgba(249,115,22,.16) !important; }
:root[data-mode="dark"] .ant-tag-gold:not(.ant-tag-has-color),
:root[data-mode="dark"] .ant-tag-warning:not(.ant-tag-has-color)    { color:#fbbf24 !important; background:rgba(234,179,8,.16) !important; }
:root[data-mode="dark"] .ant-tag-purple:not(.ant-tag-has-color)     { color:#c084fc !important; background:rgba(168,85,247,.16) !important; }
:root[data-mode="dark"] .ant-tag-magenta:not(.ant-tag-has-color),
:root[data-mode="dark"] .ant-tag-pink:not(.ant-tag-has-color)       { color:#f472b6 !important; background:rgba(236,72,153,.16) !important; }
:root[data-mode="dark"] .ant-tag-geekblue:not(.ant-tag-has-color)   { color:#818cf8 !important; background:rgba(99,102,241,.16) !important; }
:root[data-mode="dark"] .ant-tag-lime:not(.ant-tag-has-color)       { color:#a3e635 !important; background:rgba(132,204,22,.16) !important; }

/* ─── Descriptions (e.g. Fest Overview "Fest Details") ─── */
.ant-descriptions-title {
  color: var(--foreground) !important;
}
.ant-descriptions .ant-descriptions-item-label {
  color: var(--muted-foreground) !important;
}
.ant-descriptions .ant-descriptions-item-content {
  color: var(--foreground) !important;
}
.ant-descriptions-bordered .ant-descriptions-item-label {
  background: var(--muted) !important;
}
.ant-descriptions-bordered .ant-descriptions-view,
.ant-descriptions-bordered .ant-descriptions-view > table,
.ant-descriptions-bordered .ant-descriptions-row,
.ant-descriptions-bordered .ant-descriptions-item-label,
.ant-descriptions-bordered .ant-descriptions-item-content {
  border-color: var(--border) !important;
}

/* ─── Popconfirm ─── */
.ant-popconfirm .ant-popover-inner {
  background: var(--popover) !important;
}
.ant-popconfirm .ant-popconfirm-title {
  color: var(--foreground) !important;
}
.ant-popconfirm .ant-popconfirm-description {
  color: var(--muted-foreground) !important;
}

/* ─── Message ─── */
.ant-message-notice-content {
  background: var(--popover) !important;
  color: var(--foreground) !important;
  border: 1px solid var(--border) !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06) !important;
  font-size: 13px !important;
}

/* ─── Breadcrumb ─── */
.ant-breadcrumb a {
  color: var(--muted-foreground) !important;
}
.ant-breadcrumb a:hover {
  color: var(--foreground) !important;
}
.ant-breadcrumb-separator {
  color: var(--muted-foreground) !important;
}

/* ─── Tooltip ─── */
.ant-tooltip-inner {
  background: var(--popover) !important;
  color: var(--foreground) !important;
  border: 1px solid var(--border) !important;
}
.ant-tooltip-arrow::before {
  background: var(--popover) !important;
}

/* ─── Password Input ─── */
.ant-input-password {
  background: var(--card) !important;
  border-color: var(--border) !important;
}
.ant-input-password .ant-input {
  background: transparent !important;
}
.ant-input-password .ant-input-suffix .ant-input-password-icon {
  color: var(--muted-foreground) !important;
}

/* ─── Spin ─── */
.ant-spin-text {
  color: var(--muted-foreground) !important;
}

/* ─── Card ─── */
.ant-card {
  border-radius: 16px !important;
  border: 1px solid var(--border) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04) !important;
  background: var(--card) !important;
  transition: box-shadow 0.2s ease !important;
}
.ant-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
}
.ant-card-head {
  border-bottom: 1px solid var(--border) !important;
  background: var(--card) !important;
  padding: 0 20px !important;
  min-height: 48px !important;
  color: var(--foreground) !important;
  font-size: 14px !important;
  font-weight: 600 !important;
}
.ant-card-body {
  padding: 20px !important;
  color: var(--foreground) !important;
}
.ant-card-extra {
  color: var(--muted-foreground) !important;
}

/* ─── Drawer ─── */
.ant-drawer-content {
  background: var(--card) !important;
}
.ant-drawer-header {
  background: var(--card) !important;
  border-bottom: 1px solid var(--border) !important;
  padding: 16px 20px !important;
}
.ant-drawer-title {
  color: var(--foreground) !important;
  font-size: 15px !important;
  font-weight: 600 !important;
}
.ant-drawer-body {
  padding: 20px !important;
  color: var(--foreground) !important;
}
.ant-drawer-close {
  color: var(--muted-foreground) !important;
}
.ant-drawer-close:hover {
  color: var(--foreground) !important;
}

/* ─── DatePicker / TimePicker ─── */
.ant-picker {
  background: var(--card) !important;
  border-color: var(--border) !important;
  color: var(--foreground) !important;
  border-radius: 10px !important;
  font-size: 13px !important;
  height: 36px !important;
}
.ant-picker-sm {
  height: 28px !important;
  border-radius: 6px !important;
}
.ant-picker:hover {
  border-color: var(--ring) !important;
}
.ant-picker-focused {
  border-color: var(--ring) !important;
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--ring) 12%, transparent) !important;
}
.ant-picker-input > input {
  color: var(--foreground) !important;
  font-size: 13px !important;
}
.ant-picker-input > input::placeholder {
  color: var(--muted-foreground) !important;
}
.ant-picker-suffix,
.ant-picker-clear {
  color: var(--muted-foreground) !important;
}
.ant-picker-panel-container {
  background: var(--popover) !important;
  border: 1px solid var(--border) !important;
  border-radius: 14px !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06) !important;
}
.ant-picker-header {
  border-bottom: 1px solid var(--border) !important;
  color: var(--foreground) !important;
}
.ant-picker-header button {
  color: var(--foreground) !important;
}
.ant-picker-content th {
  color: var(--muted-foreground) !important;
}
.ant-picker-cell .ant-picker-cell-inner {
  color: var(--foreground) !important;
}
.ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
  background: var(--primary) !important;
  color: var(--primary-foreground) !important;
}
.ant-picker-cell:hover:not(.ant-picker-cell-selected) .ant-picker-cell-inner {
  background: var(--accent) !important;
}

/* ─── Tabs ─── */
.ant-tabs-tab {
  color: var(--muted-foreground) !important;
  font-size: 13px !important;
  font-weight: 500 !important;
}
.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: var(--primary) !important;
}
.ant-tabs-ink-bar {
  background: var(--primary) !important;
}
.ant-tabs-nav::before {
  border-bottom-color: var(--border) !important;
}

/* ─── Dropdown ─── */
.ant-dropdown-menu {
  background: var(--popover) !important;
  border: 1px solid var(--border) !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06) !important;
  padding: 4px !important;
}
.ant-dropdown-menu-item {
  color: var(--foreground) !important;
  border-radius: 6px !important;
  font-size: 13px !important;
}
.ant-dropdown-menu-item:hover {
  background: var(--accent) !important;
}
.ant-dropdown-menu-item-danger {
  color: var(--destructive) !important;
}

/* ─── Alert ─── */
.ant-alert {
  border-radius: 12px !important;
  font-size: 13px !important;
}

/* ─── Badge ─── */
.ant-badge-count {
  font-size: 11px !important;
  font-weight: 600 !important;
}

/* ─── Popover ─── */
.ant-popover-inner {
  border-radius: 14px !important;
  border: 1px solid var(--border) !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06) !important;
}

/* ─── Typography ─── */
.ant-typography {
  color: var(--foreground) !important;
}
.ant-typography.ant-typography-secondary {
  color: var(--muted-foreground) !important;
}

/* ─── Radio / Checkbox ─── */
.ant-radio-wrapper,
.ant-checkbox-wrapper {
  color: var(--foreground) !important;
  font-size: 13px !important;
}

/* ─── Suppress dropdown/select animation glitch (NOT modals) ─── */
/* Only target select/picker/menu dropdowns — leave modal animations intact */
.ant-select-dropdown,
.ant-picker-dropdown,
.ant-dropdown {
  animation-duration: 0s !important;
  animation-delay: 0s !important;
  transition-duration: 0s !important;
}

/* ─── Segmented ─── */
.ant-segmented {
  background: var(--muted) !important;
  border-radius: 8px !important;
}
.ant-segmented-item {
  border-radius: 6px !important;
  color: var(--muted-foreground) !important;
  font-size: 13px !important;
  font-weight: 500 !important;
}
.ant-segmented-item-selected {
  background: var(--card) !important;
  color: var(--foreground) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
}

/* ─── InputNumber ─── */
.ant-input-number {
  background: var(--card) !important;
  border-color: var(--border) !important;
  border-radius: 10px !important;
  font-size: 13px !important;
}
.ant-input-number-sm {
  border-radius: 6px !important;
}
.ant-input-number-input-wrap {
  position: relative !important;
  z-index: 1 !important;
}
.ant-input-number-input {
  color: var(--foreground) !important;
  cursor: text !important;
  -moz-appearance: textfield !important;
}
.ant-input-number-input::-webkit-inner-spin-button,
.ant-input-number-input::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
}
.ant-input-number:hover {
  border-color: var(--ring) !important;
}
.ant-input-number-focused,
.ant-input-number:focus-within {
  border-color: var(--ring) !important;
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--ring) 12%, transparent) !important;
}
.ant-input-number-handler-wrap {
  background: var(--card) !important;
  border-left-color: var(--border) !important;
}
.ant-input-number-handler {
  border-color: var(--border) !important;
  color: var(--muted-foreground) !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;4CAE4C;;AAE5C,2BAA2B;AAC3B;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,wEAAwE;AAC1E;;AAEA,wDAAwD;AACxD;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,wEAAwE;AAC1E;;AAEA,2BAA2B;AAC3B;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,wEAAwE;EACxE,sFAAsF;AACxF;AACA;EACE,yCAAyC;AAC3C;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;4CAE4C;;AAE5C,6DAA6D;AAC7D;EACE,qCAAqC;EACrC,uCAAuC;EACvC,iCAAiC;EACjC,2CAA2C;EAC3C,mCAAmC;EACnC,mDAAmD;EACnD,kDAAkD;EAClD,oDAAoD;EACpD,qDAAqD;EACrD,+BAA+B;EAC/B,wCAAwC;EACxC,uCAAuC;EACvC,wCAAwC;EACxC,0CAA0C;EAC1C,2CAA2C;EAC3C,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,oCAAoC;AACpC,qBAAqB,0BAA0B,EAAE,2BAA2B,EAAE,uBAAuB,EAAE;AACvG,qBAAqB,0BAA0B,EAAE,2BAA2B,EAAE,uBAAuB,EAAE;AACvG,qBAAqB,0BAA0B,EAAE,2BAA2B,EAAE;AAC9E,qBAAqB,0BAA0B,EAAE,2BAA2B,EAAE;AAC9E,qBAAqB,0BAA0B,EAAE,2BAA2B,EAAE;;AAE9E,sBAAsB;AACtB;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yCAAyC;EACzC,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,uBAAuB;AACzB;AACA;;EAEE,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA,kBAAkB;AAClB;EACE,kCAAkC;EAClC,mCAAmC;AACrC;AACA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;;EAEE,mCAAmC;EACnC,yCAAyC;EACzC,iDAAiD;EACjD,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,iDAAiD;EACjD,6BAA6B;EAC7B,0BAA0B;EAC1B,iCAAiC;AACnC;AACA;0EAC0E;AAC1E;EACE,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA,gBAAgB;AAChB;EACE,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,wCAAwC;AAC1C;AACA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;AACA,2BAA2B;AAC3B;EACE,mCAAmC;AACrC;AACA,iEAAiE;AACjE;;EAEE,qBAAqB;EACrB,0CAA0C;AAC5C;AACA;;EAEE,WAAW;EACX,UAAU;AACZ;AACA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;EAEE,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,kCAAkC;EAClC,sCAAsC;AACxC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;AACA;EACE,2CAA2C;AAC7C;AACA;;EAEE,mCAAmC;EACnC,kCAAkC;EAClC,sCAAsC;AACxC;AACA;EACE,yCAAyC;EACzC,YAAY;AACd;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA,kBAAkB;AAClB;;EAEE,kCAAkC;EAClC,sCAAsC;EACtC,mCAAmC;EACnC,8BAA8B;EAC9B,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;;EAEE,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;;EAEE,yCAAyC;AAC3C;AACA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;EACpC,iFAAiF;AACnF;AACA;EACE,yCAAyC;AAC3C;AACA,0CAA0C;AAC1C;;EAEE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,wCAAwC;EACxC,sCAAsC;EACtC,mCAAmC;EACnC,8BAA8B;EAC9B,0BAA0B;EAC1B,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,iFAAiF;AACnF;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,mCAAmC;AACrC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,wCAAwC;EACxC,yCAAyC;AAC3C;AACA,oBAAoB;AACpB;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,8BAA8B;EAC9B,qDAAqD;EACrD,uBAAuB;AACzB;AACA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;AACA,kDAAkD;AAClD;EACE,gCAAgC;AAClC;;AAEA;;;qEAGqE;AACrE;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,6CAA6C;EAC7C,0CAA0C;EAC1C,6BAA6B;EAC7B,mCAAmC;EACnC,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,mCAAmC;AACrC;;AAEA,mBAAmB;AACnB;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;EAC1B,+BAA+B;AACjC;AACA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,+BAA+B;AACjC;AACA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,kCAAkC;EAClC,sCAAsC;EACtC,mCAAmC;AACrC;AACA;;EAEE,oCAAoC;EACpC,mCAAmC;AACrC;AACA;;EAEE,mCAAmC;EACnC,oCAAoC;EACpC,kCAAkC;AACpC;AACA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,8EAA8E;AAChF;AACA;;;EAGE,qCAAqC;EACrC,uCAAuC;EACvC,2CAA2C;EAC3C,mJAAmJ;AACrJ;AACA;;;EAGE,2CAA2C;EAC3C,6CAA6C;EAC7C,2CAA2C;EAC3C,qDAAqD;EACrD,sCAAsC;AACxC;;AAEA,kBAAkB;AAClB;EACE,kCAAkC;EAClC,mCAAmC;EACnC,8BAA8B;EAC9B,qDAAqD;EACrD,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,iDAAiD;EACjD,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,8CAA8C;EAC9C,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,yCAAyC;EACzC,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;AACA;EACE,yCAAyC;EACzC,0BAA0B;AAC5B;AACA;EACE,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;;;;0CAI0C;;AAE1C,wCAAwC;AACxC;EACE,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA,+CAA+C;AAC/C;gDACgD,wBAAwB,EAAE,6BAA6B,EAAE;AACzG,gDAAgD,wBAAwB,EAAE,6BAA6B,EAAE;AACzG;gDACgD,wBAAwB,EAAE,6BAA6B,EAAE;AACzG;gDACgD,wBAAwB,EAAE,6BAA6B,EAAE;AACzG;gDACgD,wBAAwB,EAAE,6BAA6B,EAAE;AACzG;gDACgD,wBAAwB,EAAE,6BAA6B,EAAE;AACzG,gDAAgD,wBAAwB,EAAE,6BAA6B,EAAE;AACzG;gDACgD,wBAAwB,EAAE,6BAA6B,EAAE;AACzG,gDAAgD,wBAAwB,EAAE,6BAA6B,EAAE;AACzG,gDAAgD,wBAAwB,EAAE,6BAA6B,EAAE;;AAEzG,yBAAyB;AACzB;sEACsE,wBAAwB,EAAE,0CAA0C,EAAE;AAC5I,sEAAsE,wBAAwB,EAAE,yCAAyC,EAAE;AAC3I;sEACsE,wBAAwB,EAAE,yCAAyC,EAAE;AAC3I;sEACsE,wBAAwB,EAAE,yCAAyC,EAAE;AAC3I;sEACsE,wBAAwB,EAAE,0CAA0C,EAAE;AAC5I;sEACsE,wBAAwB,EAAE,yCAAyC,EAAE;AAC3I,sEAAsE,wBAAwB,EAAE,0CAA0C,EAAE;AAC5I;sEACsE,wBAAwB,EAAE,0CAA0C,EAAE;AAC5I,sEAAsE,wBAAwB,EAAE,0CAA0C,EAAE;AAC5I,sEAAsE,wBAAwB,EAAE,0CAA0C,EAAE;;AAE5I,6DAA6D;AAC7D;EACE,mCAAmC;AACrC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;;;;;EAKE,sCAAsC;AACxC;;AAEA,uBAAuB;AACvB;EACE,qCAAqC;AACvC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,yCAAyC;AAC3C;;AAEA,oBAAoB;AACpB;EACE,qCAAqC;EACrC,mCAAmC;EACnC,0CAA0C;EAC1C,8BAA8B;EAC9B,qDAAqD;EACrD,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,yCAAyC;AAC3C;AACA;EACE,mCAAmC;AACrC;AACA;EACE,yCAAyC;AAC3C;;AAEA,oBAAoB;AACpB;EACE,qCAAqC;EACrC,mCAAmC;EACnC,0CAA0C;AAC5C;AACA;EACE,qCAAqC;AACvC;;AAEA,2BAA2B;AAC3B;EACE,kCAAkC;EAClC,sCAAsC;AACxC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,mFAAmF;EACnF,kCAAkC;EAClC,2CAA2C;AAC7C;AACA;EACE,oDAAoD;AACtD;AACA;EACE,iDAAiD;EACjD,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,mCAAmC;AACrC;AACA;EACE,yCAAyC;AAC3C;;AAEA,mBAAmB;AACnB;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,iDAAiD;EACjD,6BAA6B;AAC/B;AACA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,mCAAmC;AACrC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,mCAAmC;AACrC;;AAEA,oCAAoC;AACpC;EACE,kCAAkC;EAClC,sCAAsC;EACtC,mCAAmC;EACnC,8BAA8B;EAC9B,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,iFAAiF;AACnF;AACA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;AACA;EACE,yCAAyC;AAC3C;AACA;;EAEE,yCAAyC;AAC3C;AACA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,8BAA8B;EAC9B,qDAAqD;AACvD;AACA;EACE,iDAAiD;EACjD,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,mCAAmC;AACrC;AACA;EACE,qCAAqC;EACrC,2CAA2C;AAC7C;AACA;EACE,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,yCAAyC;EACzC,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,6CAA6C;AAC/C;;AAEA,qBAAqB;AACrB;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,8BAA8B;EAC9B,qDAAqD;EACrD,uBAAuB;AACzB;AACA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;;AAEA,kBAAkB;AAClB;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA,uBAAuB;AACvB;EACE,mCAAmC;AACrC;AACA;EACE,yCAAyC;AAC3C;;AAEA,6BAA6B;AAC7B;;EAEE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA,mEAAmE;AACnE,6EAA6E;AAC7E;;;EAGE,iCAAiC;EACjC,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,yCAAyC;EACzC,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,oDAAoD;AACtD;;AAEA,wBAAwB;AACxB;EACE,kCAAkC;EAClC,sCAAsC;EACtC,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,uBAAuB;EACvB,qCAAqC;AACvC;AACA;;EAEE,mCAAmC;EACnC,oBAAoB;AACtB;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;EACpC,iFAAiF;AACnF;AACA;EACE,kCAAkC;EAClC,2CAA2C;AAC7C;AACA;EACE,sCAAsC;EACtC,yCAAyC;AAC3C","sourcesContent":["/* ═══════════════════════════════════════\n   Standard Page Layout System\n   ═══════════════════════════════════════ */\n\n/* ─── Page structure ─── */\n.page-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--foreground);\n  line-height: 1.3;\n  letter-spacing: -0.01em;\n  margin: 0;\n}\n.page-subtitle {\n  font-size: 13px;\n  color: var(--muted-foreground);\n  margin: 4px 0 0;\n  line-height: 1.4;\n}\n\n/* ─── Filter / action bar card ─── */\n.filter-card {\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  padding: 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.02);\n}\n\n/* ─── Content card wrapper (table container etc.) ─── */\n.content-card {\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.02);\n}\n\n/* ─── Dashboard card ─── */\n.dash-card {\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);\n  transition: box-shadow 0.2s ease, background-color 200ms ease, border-color 200ms ease;\n}\n.dash-card:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n\n/* ─── Consistent section spacing ─── */\n.page-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* ═══════════════════════════════════════\n   Ant Design ➜ CSS-Variable Theme Overrides\n   ═══════════════════════════════════════ */\n\n/* ─── Override Ant Design CSS Variables with our theme ─── */\n:root {\n  --ant-color-bg-container: var(--card);\n  --ant-color-bg-elevated: var(--popover);\n  --ant-color-border: var(--border);\n  --ant-color-border-secondary: var(--border);\n  --ant-color-text: var(--foreground);\n  --ant-color-text-secondary: var(--muted-foreground);\n  --ant-color-text-tertiary: var(--muted-foreground);\n  --ant-color-text-quaternary: var(--muted-foreground);\n  --ant-color-text-placeholder: var(--muted-foreground);\n  --ant-color-fill: var(--accent);\n  --ant-color-fill-secondary: var(--muted);\n  --ant-color-fill-tertiary: var(--muted);\n  --ant-color-bg-layout: var(--background);\n  --ant-control-item-bg-hover: var(--accent);\n  --ant-control-item-bg-active: var(--accent);\n  /* Global font size token */\n  --ant-font-size: 13px;\n  --ant-border-radius: 10px;\n  --ant-border-radius-sm: 8px;\n  --ant-border-radius-lg: 14px;\n}\n\n/* ─── Global font consistency ─── */\n.ant-typography h1 { font-size: 24px !important; font-weight: 700 !important; letter-spacing: -0.02em; }\n.ant-typography h2 { font-size: 20px !important; font-weight: 700 !important; letter-spacing: -0.01em; }\n.ant-typography h3 { font-size: 17px !important; font-weight: 600 !important; }\n.ant-typography h4 { font-size: 15px !important; font-weight: 600 !important; }\n.ant-typography h5 { font-size: 13px !important; font-weight: 600 !important; }\n\n/* ─── Statistic ─── */\n.ant-statistic-title {\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  color: var(--muted-foreground) !important;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n.ant-statistic-content-value {\n  font-size: 26px !important;\n  font-weight: 700 !important;\n  color: var(--foreground) !important;\n  letter-spacing: -0.02em;\n}\n.ant-statistic-content-prefix,\n.ant-statistic-content-suffix {\n  font-size: 16px !important;\n  color: var(--muted-foreground) !important;\n}\n\n/* ─── Table ─── */\n.ant-table {\n  background: transparent !important;\n  color: var(--foreground) !important;\n}\n.ant-table-container {\n  border-radius: 14px !important;\n  overflow: hidden;\n}\n.ant-table-thead > tr > th,\n.ant-table-thead > tr > td {\n  background: var(--muted) !important;\n  color: var(--muted-foreground) !important;\n  border-bottom: 1px solid var(--border) !important;\n  font-weight: 600 !important;\n  font-size: 12px !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.03em !important;\n  padding: 10px 16px !important;\n}\n.ant-table-thead > tr > th::before {\n  display: none !important;\n}\n.ant-table-tbody > tr > td {\n  background: var(--card) !important;\n  color: var(--foreground) !important;\n  border-bottom: 1px solid var(--border) !important;\n  padding: 12px 16px !important;\n  font-size: 13px !important;\n  transition: background 0.15s ease;\n}\n/* AntD inserts a hidden measure row when scroll.x is set — keep it invisible\n   (our td padding/border rule above must NOT turn it into a blank row). */\n.ant-table-tbody > tr.ant-table-measure-row > td {\n  padding: 0 !important;\n  height: 0 !important;\n  border: 0 !important;\n}\n.ant-table-tbody > tr:hover > td {\n  background: var(--accent) !important;\n}\n.ant-table-tbody > tr.ant-table-row-selected > td {\n  background: var(--accent) !important;\n}\n/* Empty state */\n.ant-table-placeholder td {\n  background: var(--card) !important;\n  border-bottom: none !important;\n}\n.ant-table-placeholder:hover td {\n  background: var(--card) !important;\n}\n.ant-empty-description {\n  color: var(--muted-foreground) !important;\n}\n.ant-empty-image svg {\n  fill: var(--muted-foreground) !important;\n}\n/* Table wrapper */\n.ant-table-wrapper {\n  border-radius: 16px;\n}\n/* Cell text inside table */\n.ant-table-cell {\n  color: var(--foreground) !important;\n}\n/* Thin scrollbar for horizontally/vertically scrollable tables */\n.ant-table-body,\n.ant-table-content {\n  scrollbar-width: thin;\n  scrollbar-color: var(--border) transparent;\n}\n.ant-table-body::-webkit-scrollbar,\n.ant-table-content::-webkit-scrollbar {\n  height: 8px;\n  width: 8px;\n}\n.ant-table-body::-webkit-scrollbar-thumb,\n.ant-table-content::-webkit-scrollbar-thumb {\n  background: var(--border);\n  border-radius: 4px;\n}\n.ant-table-body::-webkit-scrollbar-track,\n.ant-table-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n/* ─── Pagination ─── */\n.ant-pagination .ant-pagination-item {\n  background: var(--card) !important;\n  border-color: var(--border) !important;\n}\n.ant-pagination .ant-pagination-item a {\n  color: var(--foreground) !important;\n}\n.ant-pagination .ant-pagination-item-active {\n  background: var(--primary) !important;\n  border-color: var(--primary) !important;\n}\n.ant-pagination .ant-pagination-item-active a {\n  color: var(--primary-foreground) !important;\n}\n.ant-pagination .ant-pagination-prev .ant-pagination-item-link,\n.ant-pagination .ant-pagination-next .ant-pagination-item-link {\n  color: var(--foreground) !important;\n  background: var(--card) !important;\n  border-color: var(--border) !important;\n}\n.ant-pagination .ant-pagination-disabled .ant-pagination-item-link {\n  color: var(--muted-foreground) !important;\n  opacity: 0.5;\n}\n.ant-pagination .ant-pagination-total-text {\n  color: var(--muted-foreground) !important;\n}\n.ant-pagination .ant-pagination-options .ant-select-selector {\n  background: var(--card) !important;\n  border-color: var(--border) !important;\n  color: var(--foreground) !important;\n}\n\n/* ─── Input ─── */\n.ant-input,\n.ant-input-affix-wrapper {\n  background: var(--card) !important;\n  border-color: var(--border) !important;\n  color: var(--foreground) !important;\n  border-radius: 10px !important;\n  font-size: 13px !important;\n  height: 36px !important;\n}\n.ant-input-affix-wrapper .ant-input {\n  height: auto !important;\n}\n.ant-input-sm,\n.ant-input-affix-wrapper-sm {\n  height: 28px !important;\n  border-radius: 6px !important;\n  font-size: 12px !important;\n}\n.ant-input-lg,\n.ant-input-affix-wrapper-lg {\n  height: 42px !important;\n  border-radius: 10px !important;\n  font-size: 14px !important;\n}\n.ant-input::placeholder,\n.ant-input-affix-wrapper .ant-input::placeholder {\n  color: var(--muted-foreground) !important;\n}\n.ant-input:hover,\n.ant-input-affix-wrapper:hover {\n  border-color: var(--ring) !important;\n}\n.ant-input:focus,\n.ant-input-affix-wrapper-focused {\n  border-color: var(--ring) !important;\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--ring) 12%, transparent) !important;\n}\n.ant-input-prefix {\n  color: var(--muted-foreground) !important;\n}\n/* TextArea should not have fixed height */\n.ant-input[type=\"textarea\"],\ntextarea.ant-input {\n  height: auto !important;\n  min-height: 80px;\n}\n\n/* ─── Select ─── */\n.ant-select .ant-select-selector {\n  background-color: var(--card) !important;\n  border-color: var(--border) !important;\n  color: var(--foreground) !important;\n  border-radius: 10px !important;\n  font-size: 13px !important;\n  height: 36px !important;\n  align-items: center !important;\n}\n.ant-select-sm .ant-select-selector {\n  height: 28px !important;\n  border-radius: 6px !important;\n  font-size: 12px !important;\n}\n.ant-select-lg .ant-select-selector {\n  height: 42px !important;\n  border-radius: 10px !important;\n  font-size: 14px !important;\n}\n.ant-select:hover .ant-select-selector {\n  border-color: var(--ring) !important;\n}\n.ant-select-focused .ant-select-selector {\n  border-color: var(--ring) !important;\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--ring) 12%, transparent) !important;\n}\n.ant-select-selection-placeholder {\n  color: var(--muted-foreground) !important;\n}\n.ant-select-selection-item {\n  color: var(--foreground) !important;\n}\n.ant-select-arrow {\n  color: var(--muted-foreground) !important;\n}\n.ant-select-clear {\n  background-color: var(--card) !important;\n  color: var(--muted-foreground) !important;\n}\n/* Select dropdown */\n.ant-select-dropdown {\n  background-color: var(--popover) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 12px !important;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06) !important;\n  padding: 4px !important;\n}\n.ant-select-item {\n  color: var(--foreground) !important;\n  border-radius: 6px !important;\n  font-size: 13px !important;\n}\n.ant-select-item-option-active {\n  background-color: var(--accent) !important;\n}\n.ant-select-item-option-selected {\n  background-color: var(--accent) !important;\n  color: var(--foreground) !important;\n}\n/* Checkmark on selected options (multiple mode) */\n.ant-select-item-option-selected .ant-select-item-option-state {\n  color: var(--primary) !important;\n}\n\n/* ─── Multiple select — grow with tag chips instead of a fixed height ───\n   The single-select rules above pin .ant-select-selector to a fixed height,\n   which clips the tag chips of a multiple select when they wrap. Let the\n   box grow (min-height) and style the chips for the current theme. */\n.ant-select-multiple .ant-select-selector {\n  height: auto !important;\n  min-height: 36px !important;\n  padding-block: 3px !important;\n  padding-inline: 4px !important;\n  align-items: center !important;\n}\n.ant-select-sm.ant-select-multiple .ant-select-selector {\n  height: auto !important;\n  min-height: 28px !important;\n}\n.ant-select-lg.ant-select-multiple .ant-select-selector {\n  height: auto !important;\n  min-height: 42px !important;\n}\n.ant-select-multiple .ant-select-selection-item {\n  background-color: var(--secondary) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 6px !important;\n  color: var(--foreground) !important;\n  height: 24px !important;\n  line-height: 22px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n}\n.ant-select-sm.ant-select-multiple .ant-select-selection-item {\n  height: 20px !important;\n  line-height: 18px !important;\n  font-size: 11px !important;\n}\n.ant-select-multiple .ant-select-selection-item-remove {\n  color: var(--muted-foreground) !important;\n  display: inline-flex !important;\n  align-items: center !important;\n}\n.ant-select-multiple .ant-select-selection-item-remove:hover {\n  color: var(--foreground) !important;\n}\n\n/* ─── Button ─── */\n.ant-btn {\n  height: 36px !important;\n  border-radius: 10px !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  padding-inline: 14px !important;\n  box-shadow: none !important;\n  transition: all 0.15s ease !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n}\n.ant-btn.ant-btn-sm {\n  height: 28px !important;\n  border-radius: 6px !important;\n  font-size: 12px !important;\n  padding-inline: 10px !important;\n}\n.ant-btn.ant-btn-lg {\n  height: 42px !important;\n  border-radius: 10px !important;\n  font-size: 14px !important;\n  padding-inline: 18px !important;\n}\n.ant-btn.ant-btn-circle {\n  width: 36px !important;\n  padding-inline: 0 !important;\n  border-radius: 50% !important;\n}\n.ant-btn.ant-btn-circle.ant-btn-sm {\n  width: 28px !important;\n}\n.ant-btn-default,\n.ant-btn-variant-outlined {\n  background: var(--card) !important;\n  border-color: var(--border) !important;\n  color: var(--foreground) !important;\n}\n.ant-btn-default:hover,\n.ant-btn-variant-outlined:hover {\n  border-color: var(--ring) !important;\n  color: var(--foreground) !important;\n}\n.ant-btn-text,\n.ant-btn-variant-text {\n  color: var(--foreground) !important;\n  border-color: transparent !important;\n  background: transparent !important;\n}\n.ant-btn-text:hover,\n.ant-btn-variant-text:hover {\n  background: var(--accent) !important;\n}\n.ant-btn-text.ant-btn-dangerous,\n.ant-btn-variant-text.ant-btn-dangerous {\n  color: var(--destructive) !important;\n}\n.ant-btn-text.ant-btn-dangerous:hover,\n.ant-btn-variant-text.ant-btn-dangerous:hover {\n  background: color-mix(in srgb, var(--destructive) 10%, transparent) !important;\n}\n.ant-btn-primary,\n.ant-btn-variant-solid,\n.ant-btn-color-primary.ant-btn-variant-solid {\n  background: var(--primary) !important;\n  border-color: var(--primary) !important;\n  color: var(--primary-foreground) !important;\n  box-shadow: 0 1px 3px color-mix(in srgb, var(--primary) 20%, transparent), 0 1px 2px color-mix(in srgb, var(--primary) 12%, transparent) !important;\n}\n.ant-btn-primary:hover,\n.ant-btn-variant-solid:hover,\n.ant-btn-color-primary.ant-btn-variant-solid:hover {\n  background: var(--primary-hover) !important;\n  border-color: var(--primary-hover) !important;\n  color: var(--primary-foreground) !important;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15) !important;\n  transform: translateY(-1px) !important;\n}\n\n/* ─── Modal ─── */\n.ant-modal-content {\n  background: var(--card) !important;\n  color: var(--foreground) !important;\n  border-radius: 16px !important;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08) !important;\n  padding: 0 !important;\n  overflow: hidden;\n}\n.ant-modal-header {\n  background: var(--card) !important;\n  border-bottom: 1px solid var(--border) !important;\n  padding: 16px 24px !important;\n  margin: 0 !important;\n}\n.ant-modal-title {\n  color: var(--foreground) !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n}\n.ant-modal-body {\n  padding: 20px 24px !important;\n}\n.ant-modal-footer {\n  border-top: 1px solid var(--border) !important;\n  padding: 12px 24px !important;\n  margin: 0 !important;\n}\n.ant-modal-close {\n  color: var(--muted-foreground) !important;\n  top: 14px !important;\n  right: 16px !important;\n}\n.ant-modal-close:hover {\n  color: var(--foreground) !important;\n  background: var(--accent) !important;\n}\n\n/* ─── Form ─── */\n.ant-form-item-label > label {\n  color: var(--foreground) !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n}\n.ant-form-item-explain-error {\n  color: var(--destructive) !important;\n  font-size: 12px !important;\n}\n.ant-form-item-extra {\n  color: var(--muted-foreground) !important;\n  font-size: 12px !important;\n}\n.ant-form-item {\n  margin-bottom: 16px !important;\n}\n\n/* ─── Tag ─── */\n.ant-tag {\n  border-radius: 6px !important;\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  padding: 2px 8px !important;\n  line-height: 20px !important;\n  border: none !important;\n}\n/* Theme-aware preset tag colors — we set BOTH text and background per preset,\n   per theme, so tags are always legible regardless of Ant Design's algorithm\n   state (which proved unreliable across theme switches). Status hues stay\n   semantic per the design system. Solid custom-hex tags (.ant-tag-has-color)\n   keep their own fill and are excluded. */\n\n/* Default / neutral (no preset color) */\n.ant-tag:not(.ant-tag-has-color) {\n  color: var(--muted-foreground) !important;\n  background: var(--muted) !important;\n}\n\n/* ── Light (default for all light themes) ── */\n.ant-tag-blue:not(.ant-tag-has-color),\n.ant-tag-processing:not(.ant-tag-has-color)   { color:#2563eb !important; background:#eff6ff !important; }\n.ant-tag-cyan:not(.ant-tag-has-color)         { color:#0891b2 !important; background:#ecfeff !important; }\n.ant-tag-green:not(.ant-tag-has-color),\n.ant-tag-success:not(.ant-tag-has-color)      { color:#16a34a !important; background:#f0fdf4 !important; }\n.ant-tag-red:not(.ant-tag-has-color),\n.ant-tag-error:not(.ant-tag-has-color)        { color:#dc2626 !important; background:#fef2f2 !important; }\n.ant-tag-orange:not(.ant-tag-has-color),\n.ant-tag-volcano:not(.ant-tag-has-color)      { color:#ea580c !important; background:#fff7ed !important; }\n.ant-tag-gold:not(.ant-tag-has-color),\n.ant-tag-warning:not(.ant-tag-has-color)      { color:#b45309 !important; background:#fffbeb !important; }\n.ant-tag-purple:not(.ant-tag-has-color)       { color:#9333ea !important; background:#faf5ff !important; }\n.ant-tag-magenta:not(.ant-tag-has-color),\n.ant-tag-pink:not(.ant-tag-has-color)         { color:#db2777 !important; background:#fdf2f8 !important; }\n.ant-tag-geekblue:not(.ant-tag-has-color)     { color:#4f46e5 !important; background:#eef2ff !important; }\n.ant-tag-lime:not(.ant-tag-has-color)         { color:#65a30d !important; background:#f7fee7 !important; }\n\n/* ── Dark overrides ── */\n:root[data-mode=\"dark\"] .ant-tag-blue:not(.ant-tag-has-color),\n:root[data-mode=\"dark\"] .ant-tag-processing:not(.ant-tag-has-color) { color:#60a5fa !important; background:rgba(59,130,246,.16) !important; }\n:root[data-mode=\"dark\"] .ant-tag-cyan:not(.ant-tag-has-color)       { color:#22d3ee !important; background:rgba(6,182,212,.16) !important; }\n:root[data-mode=\"dark\"] .ant-tag-green:not(.ant-tag-has-color),\n:root[data-mode=\"dark\"] .ant-tag-success:not(.ant-tag-has-color)    { color:#4ade80 !important; background:rgba(34,197,94,.16) !important; }\n:root[data-mode=\"dark\"] .ant-tag-red:not(.ant-tag-has-color),\n:root[data-mode=\"dark\"] .ant-tag-error:not(.ant-tag-has-color)      { color:#f87171 !important; background:rgba(239,68,68,.16) !important; }\n:root[data-mode=\"dark\"] .ant-tag-orange:not(.ant-tag-has-color),\n:root[data-mode=\"dark\"] .ant-tag-volcano:not(.ant-tag-has-color)    { color:#fb923c !important; background:rgba(249,115,22,.16) !important; }\n:root[data-mode=\"dark\"] .ant-tag-gold:not(.ant-tag-has-color),\n:root[data-mode=\"dark\"] .ant-tag-warning:not(.ant-tag-has-color)    { color:#fbbf24 !important; background:rgba(234,179,8,.16) !important; }\n:root[data-mode=\"dark\"] .ant-tag-purple:not(.ant-tag-has-color)     { color:#c084fc !important; background:rgba(168,85,247,.16) !important; }\n:root[data-mode=\"dark\"] .ant-tag-magenta:not(.ant-tag-has-color),\n:root[data-mode=\"dark\"] .ant-tag-pink:not(.ant-tag-has-color)       { color:#f472b6 !important; background:rgba(236,72,153,.16) !important; }\n:root[data-mode=\"dark\"] .ant-tag-geekblue:not(.ant-tag-has-color)   { color:#818cf8 !important; background:rgba(99,102,241,.16) !important; }\n:root[data-mode=\"dark\"] .ant-tag-lime:not(.ant-tag-has-color)       { color:#a3e635 !important; background:rgba(132,204,22,.16) !important; }\n\n/* ─── Descriptions (e.g. Fest Overview \"Fest Details\") ─── */\n.ant-descriptions-title {\n  color: var(--foreground) !important;\n}\n.ant-descriptions .ant-descriptions-item-label {\n  color: var(--muted-foreground) !important;\n}\n.ant-descriptions .ant-descriptions-item-content {\n  color: var(--foreground) !important;\n}\n.ant-descriptions-bordered .ant-descriptions-item-label {\n  background: var(--muted) !important;\n}\n.ant-descriptions-bordered .ant-descriptions-view,\n.ant-descriptions-bordered .ant-descriptions-view > table,\n.ant-descriptions-bordered .ant-descriptions-row,\n.ant-descriptions-bordered .ant-descriptions-item-label,\n.ant-descriptions-bordered .ant-descriptions-item-content {\n  border-color: var(--border) !important;\n}\n\n/* ─── Popconfirm ─── */\n.ant-popconfirm .ant-popover-inner {\n  background: var(--popover) !important;\n}\n.ant-popconfirm .ant-popconfirm-title {\n  color: var(--foreground) !important;\n}\n.ant-popconfirm .ant-popconfirm-description {\n  color: var(--muted-foreground) !important;\n}\n\n/* ─── Message ─── */\n.ant-message-notice-content {\n  background: var(--popover) !important;\n  color: var(--foreground) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 12px !important;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06) !important;\n  font-size: 13px !important;\n}\n\n/* ─── Breadcrumb ─── */\n.ant-breadcrumb a {\n  color: var(--muted-foreground) !important;\n}\n.ant-breadcrumb a:hover {\n  color: var(--foreground) !important;\n}\n.ant-breadcrumb-separator {\n  color: var(--muted-foreground) !important;\n}\n\n/* ─── Tooltip ─── */\n.ant-tooltip-inner {\n  background: var(--popover) !important;\n  color: var(--foreground) !important;\n  border: 1px solid var(--border) !important;\n}\n.ant-tooltip-arrow::before {\n  background: var(--popover) !important;\n}\n\n/* ─── Password Input ─── */\n.ant-input-password {\n  background: var(--card) !important;\n  border-color: var(--border) !important;\n}\n.ant-input-password .ant-input {\n  background: transparent !important;\n}\n.ant-input-password .ant-input-suffix .ant-input-password-icon {\n  color: var(--muted-foreground) !important;\n}\n\n/* ─── Spin ─── */\n.ant-spin-text {\n  color: var(--muted-foreground) !important;\n}\n\n/* ─── Card ─── */\n.ant-card {\n  border-radius: 16px !important;\n  border: 1px solid var(--border) !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04) !important;\n  background: var(--card) !important;\n  transition: box-shadow 0.2s ease !important;\n}\n.ant-card:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;\n}\n.ant-card-head {\n  border-bottom: 1px solid var(--border) !important;\n  background: var(--card) !important;\n  padding: 0 20px !important;\n  min-height: 48px !important;\n  color: var(--foreground) !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n}\n.ant-card-body {\n  padding: 20px !important;\n  color: var(--foreground) !important;\n}\n.ant-card-extra {\n  color: var(--muted-foreground) !important;\n}\n\n/* ─── Drawer ─── */\n.ant-drawer-content {\n  background: var(--card) !important;\n}\n.ant-drawer-header {\n  background: var(--card) !important;\n  border-bottom: 1px solid var(--border) !important;\n  padding: 16px 20px !important;\n}\n.ant-drawer-title {\n  color: var(--foreground) !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n}\n.ant-drawer-body {\n  padding: 20px !important;\n  color: var(--foreground) !important;\n}\n.ant-drawer-close {\n  color: var(--muted-foreground) !important;\n}\n.ant-drawer-close:hover {\n  color: var(--foreground) !important;\n}\n\n/* ─── DatePicker / TimePicker ─── */\n.ant-picker {\n  background: var(--card) !important;\n  border-color: var(--border) !important;\n  color: var(--foreground) !important;\n  border-radius: 10px !important;\n  font-size: 13px !important;\n  height: 36px !important;\n}\n.ant-picker-sm {\n  height: 28px !important;\n  border-radius: 6px !important;\n}\n.ant-picker:hover {\n  border-color: var(--ring) !important;\n}\n.ant-picker-focused {\n  border-color: var(--ring) !important;\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--ring) 12%, transparent) !important;\n}\n.ant-picker-input > input {\n  color: var(--foreground) !important;\n  font-size: 13px !important;\n}\n.ant-picker-input > input::placeholder {\n  color: var(--muted-foreground) !important;\n}\n.ant-picker-suffix,\n.ant-picker-clear {\n  color: var(--muted-foreground) !important;\n}\n.ant-picker-panel-container {\n  background: var(--popover) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 14px !important;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06) !important;\n}\n.ant-picker-header {\n  border-bottom: 1px solid var(--border) !important;\n  color: var(--foreground) !important;\n}\n.ant-picker-header button {\n  color: var(--foreground) !important;\n}\n.ant-picker-content th {\n  color: var(--muted-foreground) !important;\n}\n.ant-picker-cell .ant-picker-cell-inner {\n  color: var(--foreground) !important;\n}\n.ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {\n  background: var(--primary) !important;\n  color: var(--primary-foreground) !important;\n}\n.ant-picker-cell:hover:not(.ant-picker-cell-selected) .ant-picker-cell-inner {\n  background: var(--accent) !important;\n}\n\n/* ─── Tabs ─── */\n.ant-tabs-tab {\n  color: var(--muted-foreground) !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n}\n.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: var(--primary) !important;\n}\n.ant-tabs-ink-bar {\n  background: var(--primary) !important;\n}\n.ant-tabs-nav::before {\n  border-bottom-color: var(--border) !important;\n}\n\n/* ─── Dropdown ─── */\n.ant-dropdown-menu {\n  background: var(--popover) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 12px !important;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06) !important;\n  padding: 4px !important;\n}\n.ant-dropdown-menu-item {\n  color: var(--foreground) !important;\n  border-radius: 6px !important;\n  font-size: 13px !important;\n}\n.ant-dropdown-menu-item:hover {\n  background: var(--accent) !important;\n}\n.ant-dropdown-menu-item-danger {\n  color: var(--destructive) !important;\n}\n\n/* ─── Alert ─── */\n.ant-alert {\n  border-radius: 12px !important;\n  font-size: 13px !important;\n}\n\n/* ─── Badge ─── */\n.ant-badge-count {\n  font-size: 11px !important;\n  font-weight: 600 !important;\n}\n\n/* ─── Popover ─── */\n.ant-popover-inner {\n  border-radius: 14px !important;\n  border: 1px solid var(--border) !important;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06) !important;\n}\n\n/* ─── Typography ─── */\n.ant-typography {\n  color: var(--foreground) !important;\n}\n.ant-typography.ant-typography-secondary {\n  color: var(--muted-foreground) !important;\n}\n\n/* ─── Radio / Checkbox ─── */\n.ant-radio-wrapper,\n.ant-checkbox-wrapper {\n  color: var(--foreground) !important;\n  font-size: 13px !important;\n}\n\n/* ─── Suppress dropdown/select animation glitch (NOT modals) ─── */\n/* Only target select/picker/menu dropdowns — leave modal animations intact */\n.ant-select-dropdown,\n.ant-picker-dropdown,\n.ant-dropdown {\n  animation-duration: 0s !important;\n  animation-delay: 0s !important;\n  transition-duration: 0s !important;\n}\n\n/* ─── Segmented ─── */\n.ant-segmented {\n  background: var(--muted) !important;\n  border-radius: 8px !important;\n}\n.ant-segmented-item {\n  border-radius: 6px !important;\n  color: var(--muted-foreground) !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n}\n.ant-segmented-item-selected {\n  background: var(--card) !important;\n  color: var(--foreground) !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;\n}\n\n/* ─── InputNumber ─── */\n.ant-input-number {\n  background: var(--card) !important;\n  border-color: var(--border) !important;\n  border-radius: 10px !important;\n  font-size: 13px !important;\n}\n.ant-input-number-sm {\n  border-radius: 6px !important;\n}\n.ant-input-number-input-wrap {\n  position: relative !important;\n  z-index: 1 !important;\n}\n.ant-input-number-input {\n  color: var(--foreground) !important;\n  cursor: text !important;\n  -moz-appearance: textfield !important;\n}\n.ant-input-number-input::-webkit-inner-spin-button,\n.ant-input-number-input::-webkit-outer-spin-button {\n  -webkit-appearance: none !important;\n  margin: 0 !important;\n}\n.ant-input-number:hover {\n  border-color: var(--ring) !important;\n}\n.ant-input-number-focused,\n.ant-input-number:focus-within {\n  border-color: var(--ring) !important;\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--ring) 12%, transparent) !important;\n}\n.ant-input-number-handler-wrap {\n  background: var(--card) !important;\n  border-left-color: var(--border) !important;\n}\n.ant-input-number-handler {\n  border-color: var(--border) !important;\n  color: var(--muted-foreground) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
